import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  Actions,
  createEffect,
  ofType
} from "@ngrx/effects";
import {
  Action,
  Store
} from "@ngrx/store";
import {
  of
} from "rxjs";
import {
  catchError,
  exhaustMap,
  map,
  mergeMap,
  tap
} from "rxjs/operators";
import {
  ProgramOfficeInformationResponseModel
} from "../../domain";
import * as ProgramOfficeInfoAction from "./program-office-members-info.action";
import { ProgramOfficeInfoActionTypes } from "./program-office-members-info.action";
import { ProgramOfficeService } from "../../service/program-office.service";

@Injectable()
export class ProgramOfficeInfoEffect {

  getProgramOfficeInfo$ = createEffect(() => this.actions$.pipe(
    ofType<ProgramOfficeInfoAction.ProgramOfficeInfo>(ProgramOfficeInfoActionTypes.ProgramOfficeInfo),
    exhaustMap(() =>
      this.programOfficeService.getProgramOfficeInfo().pipe(
        map((data: ProgramOfficeInformationResponseModel) => new ProgramOfficeInfoAction.ProgramOfficeInfoSuccess(data)),
        catchError((err: HttpErrorResponse) => of(new ProgramOfficeInfoAction.ProgramOfficeInfoFault(err.message)))
      )
    )
  )
  );

  constructor(private actions$: Actions, private store$: Store<any>, private programOfficeService: ProgramOfficeService) {
  }
}
